<template>
    <div>
        <b-row>
            <b-col>
                    <app-filters @filters="onFilter" @clear="onClearFilters" />
            </b-col>
        </b-row>
        <app-data-table ref="events-table" resource="events" :fields="fields" :hard-filters="hardFilters" actions>
            <template #buttons>
                <app-btn-create v-if="userCan('crear-eventos')" @click="newEvent"><i class="fas fa-plus"></i> Crear Evento</app-btn-create>
            </template>
            <template #cell(event_date)="{ item }">
                {{ item.event_date | datetime }}
            </template>
            <template #cell(entry_at)="{ item }">
                {{ item.entry_at | datetime }}
            </template>
            <template v-slot:cell(actions)="{ item }">
                <b-btn variant="primary" :id="`btn-options-${item.id}`" size="sm"> <i class="fas fa-cogs"></i> Opciones </b-btn>
                    <b-popover :target="`btn-options-${item.id}`" triggers="click blur">
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('enviar-invitaciones-eventos')"
                                            title="Enviar invitaciones"
                                            variant="primary"
                                            size="sm"
                                            block
                                            @click="openInvitationsWindow(item)"
                                            ><i class="fas fa-paper-plane"></i> Enviar invitaciones</b-btn
                                        >
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('crear-eventos')"
                                            block
                                            title="Editar"
                                            variant="primary"
                                            size="sm"
                                            @click="edit(item)"
                                            ><i class="fas fa-edit"></i> Editar</b-btn
                                        >
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('crear-eventos')"
                                            block
                                            title="Cancelar evento"
                                            variant="warning"
                                            size="sm"
                                            @click="cancel(item)"
                                            ><i class="fas fa-ban"></i> Cancelar</b-btn
                                        >
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('crear-eventos')"
                                            block
                                            title="Aplazar evento"
                                            variant="info"
                                            size="sm"
                                            @click="postpone(item)"
                                            ><i class="fas fa-clock"></i> Aplazar</b-btn
                                        >
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('registrar-ingreso-evento')"
                                            title="Registrar ingresos"
                                            variant="confirm"
                                            size="sm"
                                            block
                                            @click="registerEntries(item)"
                                            ><i class="fas fa-door-open"></i> Registrar ingresos
                                        </b-btn>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn title="Ver información del evento" block variant="success" size="sm" @click="viewInfo(item)"
                                            ><i class="far fa-chart-bar"></i> Ver información
                                        </b-btn>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('crear-eventos')"
                                            title="Expositores"
                                            variant="primary"
                                            block
                                            size="sm"
                                            @click="viewExhibitors(item)"
                                            ><i class="fas fa-user-tie"></i> Ver expositores</b-btn
                                        >
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('enviar-certificados')"
                                            title="Enviar certificados de participación"
                                            variant="primary"
                                            size="sm"
                                            block
                                            @click="sendCertificates(item)"
                                            ><i class="fas fa-certificate"></i> Enviar certificados</b-btn
                                        >
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-btn
                                            v-if="userCan('crear-eventos')"
                                            block
                                            title="Eliminar Evento"
                                            variant="danger"
                                            size="sm"
                                            @click="remove(item)"
                                            ><i class="fas fa-trash"></i> Eliminar</b-btn
                                        >
                                    </b-col> 
                                </b-row>
                        </b-popover>
                    </template>
                </app-data-table>
        <app-modal title="Formulario de evento" id="event-form-window" @ok="$refs['event-form'].save()" ok-title="Guardar" ok-icon="fas fa-save">
            <app-event-form @success="onSuccess" ref="event-form" :current-event="selectedEvent"></app-event-form>
        </app-modal>

        <app-modal
            title="Envío de invitaciones"
            id="event-invitations-window"
            size="xl"
            ok-title="Enviar invitaciones"
            ok-icon="fas fa-paper-plane"
            hide-footer
        >
            <div v-if="!!selectedEvent">
                <app-event-invitation-form :event="selectedEvent"></app-event-invitation-form>
            </div>
        </app-modal>
        <app-modal title="Información del evento" id="event-info-window" ok-only>
            <div v-if="!!selectedEvent">
                <app-event-info :event="selectedEvent"></app-event-info>
            </div>
        </app-modal>
    </div>
</template>

<script>
import appEventsFilters from './EventsFilters'
import appEventForm from './EventForm'
import appFilters from './Filters.vue'
import appEventInvitationForm from './EventInvitationForm'
import { mapMutations } from 'vuex'
import { SET_CURRENT_EVENT } from '@store/_mutations'
import appEventInfo from './EventInfo'

export default {
    components: {
        appEventsFilters,
        appEventForm,
        appEventInvitationForm,
        appEventInfo,
        appFilters,
    },
    data: () => ({
        currentPage: 1,
        fields,
        selectedEvent: null,
        filters: {},
    }),
    computed: {
        hardFilters() {
            return {
                ...this.filters,
                venueId: this.currentVenue.id,
                sortBy: 'created_at',
                sortDir: 'desc',
            }
        },
    },
    methods: {
        ...mapMutations({
            setCurrentEvent: SET_CURRENT_EVENT,
        }),
        edit(event) {},
        cancel(event) {},
        postpone(event) {},
        remove(event) {},
        onSuccess(event) {
            this.$refs['events-table'].refresh()
            toastr.success('Evento guardado satisfactoriamente')
            this.closeModal('event-form-window')
        },
        openInvitationsWindow(event) {
            this.selectedEvent = event
            this.openModal('event-invitations-window')
        },
        newEvent() {
            this.selectedEvent = null
            this.openModal('event-form-window')
        },
        registerEntries(event) {
            this.setCurrentEvent(event)
            this.$router.push({
                name: 'eventsRegisterEntries',
                params: {
                    eventId: event.id,
                    eventName: event.name,
                    eventDate: event.event_date,
                },
            })
        },
        viewInfo(event) {
            this.selectedEvent = event
            this.openModal('event-info-window')
        },
        viewExhibitors(event) {
            this.setCurrentEvent(event)
            this.$router.push({ name: 'eventExhibitors' })
        },
        async sendCertificates(event) {
            try {
                const val = await this.confirm('¿Esta seguro de enviar los certificados de participación?')
                if (!val) return

                const { data } = await this.$repo.post(`events/${event.id}/send-certificates`)

                toastr.success(`Los certificados de participación estan siendo enviados a los participantes`)
            } catch (error) {
                toastr.error('Ocurrió un error al enviar los certificados, por favor intente de nuevo más tarde')
            }
        },
        onFilter(filters) {
            this.filters = filters
            this.$refs['events-table'].refresh()
        },
        onClearFilters() {
            this.$refs['events-table'].refresh()
        },
    },
}

const fields = [
    {
        key: 'name',
        label: 'Evento',
    },
    {
        key: 'event_date',
        label: 'Fecha',
    },
    {
        key: 'entry_at',
        label: 'Abierto desde',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>

<style></style>
